import styles from "./Background.module.css";

import background from "../../../media/Brothers/brothersBanner.JPG";

const BackgroundBrothers = () => {
    return(
        <article
        className={styles.article}
        style={{ backgroundImage:  `url(${background})` }}>
            <h1 className={styles.header}>Brothers</h1>
            <h4 className={styles.headersmtxt}>Meet our brothers!</h4>
        </article>
    );
};

export default BackgroundBrothers;